import { VStack } from "@chakra-ui/react"
import React from "react"
import { GenerateGeneratedAlertsReportForm } from "../../../forms"

export const GenerateGeneratedAlertsReport: React.FC = () => {
	return (
		<VStack w="full" spacing={6}>
			<GenerateGeneratedAlertsReportForm />
		</VStack>
	)
}
